// extracted by mini-css-extract-plugin
export default {"CheckBox":"RejectReasonList_CheckBox__YN91Z"};